import { createFileRoute } from "@tanstack/react-router";
import { QuickActionsPage } from "~/features/dashboard/pages/quick-actions/pages";
import { todayQuickActionsEncountersQueryOptions, todosQueryOptions } from "~/features/dashboard/pages/quick-actions/api/queries";
import { upcomingEncountersQueryOptions } from "~/features/dashboard/pages/encounters/api/queries";
// import { appointmentsQueryOptions, todayEncounterAppointmentsQueryOptions } from "~/features/dashboard/pages/appointments/api/queries";
// import { refillsQueryOptions, todayEncounterRefillsQueryOptions } from "~/features/dashboard/pages/encounters/api/queries/refills";
import { getApiProgram } from "~/lib/utils";
import { z } from "zod"
// import { encountersQueryOptions,encounterQueryOptions ,chatHistoryQueryOptions,appointmentsQueryOptions} from "./api/queries"
// Define the search schema for this route
const encountersSearchSchema = z.object({
  encounter_id: z.string().optional(),
  tab: z.string().optional(),
})

export const Route = createFileRoute("/(dashboard)/dashboard/$program/")({
  loader: ({ context, params }) => {
    context.queryClient.ensureQueryData(todosQueryOptions(getApiProgram(params.program ?? "")))
    // context.queryClient.ensureQueryData(appointmentsQueryOptions({ limit: 10, skip: 0, program: getApiProgram(params.program), }))
    // context.queryClient.ensureQueryData(todayEncounterAppointmentsQueryOptions({ limit: 1, skip: 0, program: getApiProgram(params.program), }))
    // context.queryClient.ensureQueryData(encountersQueryOptions({ limit: 10, skip: 0, program: getApiProgram(params.program), }))
    context.queryClient.ensureQueryData(upcomingEncountersQueryOptions({ limit: 10, skip: 0, program: getApiProgram(params.program), date_filter: "all", filter: "all", status: "unresolved" }))
    // context.queryClient.ensureQueryData(refillsQueryOptions({ limit: 10, skip: 0, program: getApiProgram(params.program), }))
    // context.queryClient.ensureQueryData(todayEncounterRefillsQueryOptions({ limit: 1, skip: 0, program: getApiProgram(params.program), }))
    // context.queryClient.ensureQueryData(encountersQueryOptions({ limit: 5, skip: 0, type: "appointment", date_filter: "today", program: getApiProgram(params.program), }))
    // context.queryClient.ensureQueryData(encountersQueryOptions({ limit: 5, skip: 0, type: "refill", date_filter: "today", program: getApiProgram(params.program), }))
    // context.queryClient.ensureQueryData(todosQueryOptions(getApiProgram(params.program)))
    context.queryClient.ensureQueryData(todayQuickActionsEncountersQueryOptions({
      limit: 1,
      skip: 0,
      type: "appointment",
      // date_filter: "today",
      program: getApiProgram(params.program),
      type_sort_order: "appointment",
      status: "unresolved",
      sort: "new_old"
    }))
    context.queryClient.ensureQueryData(todayQuickActionsEncountersQueryOptions({
      limit: 1,
      skip: 0,
      type: "refill",
      // date_filter: "today",
      program: getApiProgram(params.program),
      type_sort_order: "refill",
      status: "unresolved",
      sort: "new_old"
    }))
  },
  component: () => (
    <QuickActionsPage />
  ),
  validateSearch: encountersSearchSchema,
  errorComponent: ({ error }: { error: Error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold">Quick Actions Error</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
});
